module.exports = __webpack_public_path__ + "img/10_38.c6e812a4.png";